var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.mode === 'default')?_c('v-img',{staticClass:"header-logo",attrs:{"src":require('@/assets/images/mita-logo-2.svg'),"contain":"","height":"100%"}}):_vm._e(),(_vm.mode === 'dark')?_c('v-img',{staticClass:"header-logo",attrs:{"src":require('@/assets/images/mita-logo-dark-2.svg'),"contain":"","height":"100%"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }